import createIcon from '@/lib/create-icon'

const AutoRacingIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M10.871 26.66C19.1667 30.5369 26.8333 15.0301 40.25 22.7834L34.5 5.33812C25.7291 -0.574679 16.4121 13.1416 5.75 8.86519L15.3335 42.1668'
      stroke='url(#paint0_linear_5313_272)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M10.871 26.66C19.1667 30.5369 26.8333 15.0301 40.25 22.7834L34.5 5.33812C25.7291 -0.574679 16.4121 13.1416 5.75 8.86519L15.3335 42.1668'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M10.871 26.66C19.1667 30.5369 26.8333 15.0301 40.25 22.7834L34.5 5.33812C25.7291 -0.574679 16.4121 13.1416 5.75 8.86519L15.3335 42.1668'
      stroke='url(#paint1_radial_5313_272)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M36.4167 13.4179C25.875 5.75129 17.25 23.0012 8.625 17.2511'
      stroke='url(#paint2_linear_5313_272)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M36.4167 13.4179C25.875 5.75129 17.25 23.0012 8.625 17.2511'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M36.4167 13.4179C25.875 5.75129 17.25 23.0012 8.625 17.2511'
      stroke='url(#paint3_radial_5313_272)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M15.3333 9.40079L20.745 24.9167M25.2549 5.75L30.6666 20.3531'
      stroke='url(#paint4_linear_5313_272)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M15.3333 9.40079L20.745 24.9167M25.2549 5.75L30.6666 20.3531'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M15.3333 9.40079L20.745 24.9167M25.2549 5.75L30.6666 20.3531'
      stroke='url(#paint5_radial_5313_272)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5313_272'
        x1='5.75'
        y1='3.8335'
        x2='47.7875'
        y2='30.1069'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5313_272'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 42.1668) scale(17.25 19.5208)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5313_272'
        x1='8.625'
        y1='11.4175'
        x2='14.142'
        y2='26.5624'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5313_272'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.5208 18.4481) scale(13.8958 3.58024)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_5313_272'
        x1='15.3333'
        y1='5.75'
        x2='35.187'
        y2='16.7799'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_5313_272'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.9999 24.9167) scale(7.66667 9.76038)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'AutoRacingIcon'
)

export default AutoRacingIcon
